import { log } from "./logs";
import { sendMessage } from "./iframeBridge";
import { MessageType } from "../types";

import type { IframeAction, StorageType } from "../types";

/**
 * Interface defining the structure of messages sent to the storage iframe
 */
export interface StorageMessage {
  action: IframeAction;
  key: string;
  value?: string;
  storageType: StorageType;
}

/**
 * Sends a message to the iframe for storage operations
 * Handles error logging and provides type safety
 *
 * @param message - Storage operation message with action, key and optional value
 * @returns Promise resolving to the result or undefined if an error occurred
 */
export async function postMessageToIframe<T>(
  message: StorageMessage,
): Promise<T | undefined> {
  try {
    return await sendMessage<T>({
      ...message,
      trustedRLEvent: true,
      messageType: MessageType.Storage,
    });
  } catch (error) {
    log(
      "rlink.storageError",
      {
        action: message.action,
        key: message.key,
        error: error instanceof Error ? error.message : error,
      },
      { severity: 4 },
    );
    return undefined;
  }
}
